/* NHD Oxidative Stress Test Package page. Loaded only by sections/nhd-oxtp.liquid. Scoped to #nhd-ost-test. */
/* ---------------------------------------------------------------------------
   WEBINAR OFFER WINDOW (v2 Oct 11). One place for the code and its times.
   START must match the MYOX10 start in Shopify Discounts (Tue Oct 13 6:00 PM ET).
   END is when the page reverts to $247 (Thu Oct 15 9:00 AM ET).
   Inside the window the buy button applies MYOX10 automatically at checkout.
--------------------------------------------------------------------------- */
window.NHD_OXTP_OFFER = {
  code:  'MYOX10',
  start: Date.parse('2026-10-13T18:00:00-04:00'),
  end:   Date.parse('2026-10-15T09:00:00-04:00')
};
/* =========================================================================
   CARD ANIMATIONS + LAZY LOADING - #nhd-ost-test
   Progressive enhancement: the hidden starting state only exists once this
   script adds .nhd-anim to the page root. With JS off, with reduced motion
   on, or in a browser without IntersectionObserver, every card simply shows.
   ========================================================================= */
(function(){
  var ROOT=document.getElementById('nhd-ost-test');
  if(!ROOT) return;
  var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO='IntersectionObserver' in window;

  /* --- lazy loading: every image below the fold loads on approach --- */
  var imgs=ROOT.querySelectorAll('img');
  Array.prototype.forEach.call(imgs, function(img){
    if(img.closest('.nhd-nav')) { img.setAttribute('loading','eager'); img.setAttribute('fetchpriority','high'); return; }
    if(!img.hasAttribute('loading')) img.setAttribute('loading','lazy');
    if(!img.hasAttribute('decoding')) img.setAttribute('decoding','async');
    /* fade each image in once its bytes arrive */
    if(!reduce){
      if(img.complete && img.naturalWidth) { img.classList.add('nhd-img-ready'); }
      else {
        img.classList.add('nhd-img-wait');
        img.addEventListener('load', function(){ img.classList.add('nhd-img-ready'); }, {once:true});
        img.addEventListener('error', function(){ img.classList.add('nhd-img-ready'); }, {once:true});
      }
    }
  });

  if(reduce || !hasIO) return;

  /* --- staggered card entrance --- */
  var SEL=['.nhd-mech-col','.nhd-howfits-row > div','.nhd-evidence','.nhd-marker-col','.nhd-reportfig',
           '.nhd-quest-item','.nhd-review-photo','.nhd-review-card','.nhd-anchor','.nhd-stepcard',
           '.nhd-steps8 li','.nhd-choice-col','.nhd-testi','.nhd-offer','.nhd-faq-item'].join(',');
  var cards=[].slice.call(ROOT.querySelectorAll(SEL));
  /* stagger within each group of siblings, capped so long lists never lag */
  var groupIdx=new Map();
  cards.forEach(function(el){
    var p=el.parentNode, i=groupIdx.get(p)||0;
    el.style.setProperty('--nhd-d', Math.min(i,6)*90+'ms');
    groupIdx.set(p,i+1);
    el.classList.add('nhd-card-anim');
  });
  ROOT.classList.add('nhd-anim');

  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('nhd-in'); io.unobserve(e.target); }
    });
  },{rootMargin:'0px 0px -8% 0px', threshold:0.08});
  cards.forEach(function(el){ io.observe(el); });

  /* safety nets: never leave a card hidden */
  var showAll=function(){ cards.forEach(function(el){ el.classList.add('nhd-in'); }); };
  window.addEventListener('beforeprint', showAll);
  /* anchor jumps (CTA buttons link to #nhd-offer) reveal the target at once */
  ROOT.addEventListener('click', function(ev){
    var a=ev.target.closest('a[href^="#"]'); if(!a) return;
    var t=ROOT.querySelector(a.getAttribute('href')); if(!t) return;
    [].slice.call(t.querySelectorAll('.nhd-card-anim')).concat(t.classList.contains('nhd-card-anim')?[t]:[])
      .forEach(function(el){ el.classList.add('nhd-in'); });
  });
})();

(function(){
  var ROOT=document.getElementById('nhd-ost-test');
  if(!ROOT) return;
  var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- page entrance: JS adds the classes, so with JS off or reduced motion
         on, nothing is ever hidden --- */
  if(reduce){ ROOT.classList.add('nhd-nojs'); }
  else {
    ROOT.classList.add('nhd-booting');
    var boot=function(){
      ROOT.classList.remove('nhd-booting');
      ROOT.classList.add('nhd-booted');
    };
    if(document.readyState==='complete') requestAnimationFrame(boot);
    else window.addEventListener('load', function(){ requestAnimationFrame(boot); });
    /* safety net: never leave the page hidden if load never fires */
    setTimeout(function(){ if(ROOT.classList.contains('nhd-booting')) boot(); }, 1200);
  }

  /* --- animated heart-rhythm rule ---
     Two variants. The long hero rule repeats the cycle three times across an
     840-unit box. The small section rule uses ONE cycle in a 124-unit box:
     reusing the long path at 132px squashed it into an illegible squiggle. */
  var CYC='h72 q9,-6 18,0 h30 l7,5 l7,-19 l9,34 l7,-21 l7,2 h38 q14,-8 28,0 h47';
  var D_LONG='M0,26 '+CYC+' '+CYC+' '+CYC;
  var D_SM='M0,11 h30 q4,-2.5 8,0 h12 l3,2 l3,-8 l4,15 l3,-9 l3,1 h16 q6,-3.5 12,0 h20 h10';
  function ecg(el){
    if(el.firstChild) return;
    var sm=el.classList.contains('nhd-ecg--sm');
    var d=sm?D_SM:D_LONG;
    var vb=sm?'0 0 124 22':'0 0 840 52';
    var cy=sm?11:26, rHalo=sm?7:13, rNode=sm?3.2:5.5;
    var s=document.createElementNS('http://www.w3.org/2000/svg','svg');
    s.setAttribute('viewBox',vb);
    s.setAttribute('preserveAspectRatio',sm?'xMidYMid meet':'xMinYMid meet');
    s.setAttribute('focusable','false'); s.setAttribute('aria-hidden','true');
    s.innerHTML='<circle class="nhd-halo" cx="0" cy="'+cy+'" r="'+rHalo+'"/>'+
                '<circle class="nhd-node" cx="0" cy="'+cy+'" r="'+rNode+'"/>'+
                '<path class="nhd-base" d="'+d+'"/>'+
                '<path class="nhd-scan" d="'+d+'"/>';
    el.appendChild(s);
  }
  Array.prototype.forEach.call(ROOT.querySelectorAll('.nhd-ecg'), ecg);
  Array.prototype.forEach.call(ROOT.querySelectorAll('.nhd-sec-head h2'), function(h){
    if(h.nextElementSibling && h.nextElementSibling.classList.contains('nhd-ecg')) return;
    /* a head marked .nhd-sec-head--noecg opts out of the rhythm rule */
    if(h.parentNode.classList.contains('nhd-sec-head--noecg')) return;
    var w=document.createElement('span');
    w.className='nhd-ecg nhd-ecg--sm'; w.setAttribute('aria-hidden','true');
    ecg(w); h.parentNode.insertBefore(w, h.nextSibling);
  });

  /* --- parallax on touch devices, where CSS fixed attachment is unreliable --- */
  if(!reduce){
    var layers=[].slice.call(ROOT.querySelectorAll('.nhd-hero-bg,.nhd-close-bg'));
    var touch = window.matchMedia && window.matchMedia('(hover:none)').matches;
    if(layers.length && touch){
      var ticking=false;
      /* SHIFT is the total travel across a full section transit. The layer is
         scaled up by the matching amount so no edge gap can appear. */
      var SHIFT=130, SCALE=1+(SHIFT/window.innerHeight)*1.6;
      var move=function(){
        layers.forEach(function(el){
          var sec=el.parentElement, r=sec.getBoundingClientRect();
          if(r.bottom<-160 || r.top>window.innerHeight+160) return;
          var progress=(window.innerHeight - r.top)/(window.innerHeight + r.height);
          progress=Math.max(0,Math.min(1,progress));
          el.style.transform='translate3d(0,'+((progress-0.5)*SHIFT).toFixed(1)+'px,0) scale('+SCALE.toFixed(3)+')';
          el.style.willChange='transform';
        });
        ticking=false;
      };
      window.addEventListener('resize',function(){
        SCALE=1+(SHIFT/window.innerHeight)*1.6; move();
      },{passive:true});
      window.addEventListener('scroll',function(){
        if(!ticking){ ticking=true; window.requestAnimationFrame(move); }
      },{passive:true});
      move();
    }
  }

  /* --- native lazy loading for every below-fold image --- */
  var imgs=[].slice.call(ROOT.querySelectorAll('img'));
  imgs.forEach(function(img){
    var top=img.getBoundingClientRect().top + (window.pageYOffset||0);
    if(top > window.innerHeight){
      img.setAttribute('loading','lazy');
      img.setAttribute('fetchpriority','low');
    } else if(!img.getAttribute('loading')){
      img.setAttribute('loading','eager');
    }
    if(!img.getAttribute('decoding')) img.setAttribute('decoding','async');
  });
  /* background layers are decorative: hold them back until near the viewport */
  var bgs=[].slice.call(ROOT.querySelectorAll('.nhd-close-bg'));
  if(bgs.length && 'IntersectionObserver' in window){
    bgs.forEach(function(el){
      var img=el.style.backgroundImage;
      el.dataset.bg=img; el.style.backgroundImage='none';
      var o=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){ el.style.backgroundImage=el.dataset.bg; o.unobserve(el); }
        });
      },{rootMargin:'300px 0px'});
      o.observe(el);
    });
  }

  /* --- sticky CTA only after the hero has scrolled past --- */
  var sticky=ROOT.querySelector('.nhd-sticky');
  var heroEl=ROOT.querySelector('.nhd-hero');
  if(sticky && heroEl && 'IntersectionObserver' in window){
    var hio=new IntersectionObserver(function(es){
      es.forEach(function(e){
        sticky.classList.toggle('nhd-sticky-on', !e.isIntersecting);
      });
    },{threshold:0, rootMargin:'-60px 0px 0px 0px'});
    hio.observe(heroEl);
  } else if(sticky){
    sticky.classList.add('nhd-sticky-on');
  }

  /* --- section-level reveal: every section fades up as it enters view,
         with its heading leading slightly. Applied by JS so nothing is ever
         hidden with JS off or reduced motion on. --- */
  if(!reduce && 'IntersectionObserver' in window){
    var secs=[].slice.call(ROOT.querySelectorAll('section'));
    var heads=[].slice.call(ROOT.querySelectorAll('.nhd-sec-head'));
    secs.forEach(function(s){ s.classList.add('nhd-sec-reveal'); });
    heads.forEach(function(h){ h.classList.add('nhd-head-reveal'); });
    var sio=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.classList.add('nhd-in');
        sio.unobserve(e.target);
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.04});
    secs.concat(heads).forEach(function(el){ sio.observe(el); });
    /* the first section is already in view on load - show it immediately */
    requestAnimationFrame(function(){
      secs.slice(0,1).concat(heads.slice(0,1)).forEach(function(el){ el.classList.add('nhd-in'); });
    });
  }

  /* --- hover + scroll reveal --- */
  /* the node track animates as one unit so the rail and pills stay in sync */
  if(!reduce && 'IntersectionObserver' in window){
    var tracks=[].slice.call(ROOT.querySelectorAll('.nhd-track'));
    var tio=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.classList.add('nhd-in'); tio.unobserve(e.target);
      });
    },{rootMargin:'0px 0px -12% 0px',threshold:0.25});
    tracks.forEach(function(t){ tio.observe(t); });
  } else {
    [].slice.call(ROOT.querySelectorAll('.nhd-track')).forEach(function(t){ t.classList.add('nhd-in'); });
  }

  var SEL='.nhd-card, .nhd-step, .nhd-invite-card, .nhd-doc, .nhd-when, .nhd-cd > div, '+
          '.nhd-tier, .nhd-bundle, .nhd-path, .nhd-pillar, .nhd-col, .nhd-offer, '+
          '.nhd-checks li, .nhd-quote, .nhd-faq details, .nhd-decide li, '+
          '.nhd-two-q li, .nhd-bal, .nhd-did li, .nhd-flow span, .nhd-offer, '+
          '.nhd-pcard, .nhd-testi, .nhd-levelchips span, .nhd-later span';
  var els=Array.prototype.slice.call(ROOT.querySelectorAll(SEL));
  els.forEach(function(el){ el.classList.add('nhd-hover'); });
  if(!reduce && 'IntersectionObserver' in window){
    els.forEach(function(el){ el.classList.add('nhd-reveal'); });
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        var sibs=Array.prototype.slice.call(e.target.parentNode.children);
        e.target.style.transitionDelay=(Math.min(sibs.indexOf(e.target),5)*80)+'ms';
        e.target.classList.add('nhd-in'); io.unobserve(e.target);
      });
    },{rootMargin:'0px 0px -12% 0px',threshold:0.12});
    els.forEach(function(el){ io.observe(el); });
  }

})();

/* ---------------------------------------------------------------------------
   BUY BUTTON. One click puts exactly one Oxidative Stress Test Package in the
   cart and goes to checkout. If the test is already in the cart, quantity is
   set to 1 instead of adding a second. The cart is NOT replaced, so the
   WebinarJam and Everflow cart attributes survive. If anything fails, the
   link falls through to the product page. During the webinar offer window
   it goes through /discount/MYOX10 first, so the code is already applied.
--------------------------------------------------------------------------- */
(function(){
  var VARIANT=46334828544240; /* Oxidative Stress Test Package, $247 */
  var root=document.getElementById('nhd-ost-test'); if(!root) return;
  root.addEventListener('click',function(e){
    var a=e.target.closest ? e.target.closest('[data-oxtp-buy]') : null;
    if(!a || !window.fetch) return;
    e.preventDefault();
    if(a.getAttribute('aria-busy')==='true') return;
    a.setAttribute('aria-busy','true');
    var O=window.NHD_OXTP_OFFER||{}, now=Date.now();
    var useCode=!!(O.code && now>=O.start && now<O.end);
    var withCode=function(path){ return useCode ? '/discount/'+encodeURIComponent(O.code)+'?redirect='+encodeURIComponent(path) : path; };
    var fallback=function(){ window.location.href=withCode(a.getAttribute('href')); };
    var json={'Content-Type':'application/json','Accept':'application/json'};
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      var line=null;
      (cart.items||[]).forEach(function(it){ if(it.variant_id===VARIANT && !line) line=it; });
      if(line){
        return fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:json,
          body:JSON.stringify({id:line.key,quantity:1})});
      }
      return fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:json,
        body:JSON.stringify({items:[{id:VARIANT,quantity:1}]})});
    }).then(function(r){
      if(!r.ok) throw new Error('cart '+r.status);
      window.location.href=withCode('/checkout');
    }).catch(fallback);
  });
})();

/* ---------------------------------------------------------------------------
   WebinarJam attribution. Same block as the Sept 30 Next Steps page.
   Reads wj_user and wj_l from the URL (or the wj_user_product cookie) and
   writes them, plus this page's offer hash, to Shopify cart attributes.
   WJ_OFFER_HASH: paste the Oct 13 webinar's 10-character testing offer hash
   here once Karan builds the offer (WebinarJam > Advanced > Goal tracking).
   While empty, wj_hash is not written and the pixel falls back to another
   offer, so WebinarJam would credit the wrong offer.
--------------------------------------------------------------------------- */
(function () {
  var WJ_OFFER_HASH = ''; /* TODO: Oct 13 Oxidative Stress webinar offer hash */
  function run() {
    var q = new URLSearchParams(window.location.search);
    var user = q.get('wj_user');
    var live = q.get('wj_l') || '';
    if (!user) {
      var m = document.cookie.match(/(?:^|;\s*)wj_user_product=([^;]*)/);
      if (!m) return;
      var v = {};
      decodeURIComponent(m[1]).split('&').forEach(function (p) {
        var kv = p.split('='); v[kv[0]] = kv[1];
      });
      user = v.wj_user; live = v.wj_l || '';
    }
    if (!user) return;
    var attrs = { wj_user: user, wj_l: live };
    if (WJ_OFFER_HASH) { attrs.wj_hash = WJ_OFFER_HASH; }
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }
  if (document.readyState === 'complete') { run(); }
  else { window.addEventListener('load', run); }
})();

/* =========================================================================
   36-HOUR WEBINAR OFFER SWITCH (no visible counter: removed 7 Oct at
   Paul's request). At the deadline the page reverts every price to $247.
   DEADLINE: 36 hours after the 9:00 PM ET replay email on webinar night
   (Tue Oct 13), per the post-webinar email sequence: Thu Oct 15, 9:00 AM ET.
   Set in window.NHD_OXTP_OFFER at the top of this file.
   ========================================================================= */
(function(){
  var ROOT=document.getElementById('nhd-ost-test'); if(!ROOT) return;
  var DEADLINE=(window.NHD_OXTP_OFFER||{}).end;
  var inline=ROOT.querySelectorAll('[data-nhd-cd]'), boxes=ROOT.querySelectorAll('[data-nhd-cd-boxes]');
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    var ms=DEADLINE-Date.now();
    if(ms<=0){ROOT.classList.add('nhd-offer-ended'); clearInterval(timer); return;}
    var t=Math.floor(ms/1000), h=Math.floor(t/3600), m=Math.floor(t%3600/60), s=t%60;
    Array.prototype.forEach.call(inline,function(el){el.textContent=pad(h)+':'+pad(m)+':'+pad(s);});
    Array.prototype.forEach.call(boxes,function(b){
      b.querySelector('[data-u="h"]').textContent=pad(h);
      b.querySelector('[data-u="m"]').textContent=pad(m);
      b.querySelector('[data-u="s"]').textContent=pad(s);
    });
  }
  var timer=setInterval(tick,1000); tick();
  /* copy code */
  Array.prototype.forEach.call(ROOT.querySelectorAll('.nhd-code-copy'),function(btn){
    btn.addEventListener('click',function(){
      var done=function(){btn.textContent='Copied';setTimeout(function(){btn.textContent='Copy';},2000);};
      if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText('MYOX10').then(done,done);}
      else{var x=document.createElement('textarea');x.value='MYOX10';document.body.appendChild(x);x.select();
        try{document.execCommand('copy');}catch(e){} document.body.removeChild(x);done();}
    });
  });
})();
